import React, { useRef } from "react";
import { Box, TabPanel, Tabs, TabList, Tab } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { LeadDashboard } from './components/LeadsDashboard'

const LeadsDashboard = ({setFilters}) => {
    const { t } = useTranslation();

    const componentRef = useRef();

    return (
        <Box className="dashboard-menu dashboard-menu-1col" sx={{marginTop:0}}>
            <Tabs
                orientation="horizontal"
                size="sm"
                className="dashboard-tabs"
            >
                <TabPanel value={0} className="dashboard-tab-panel">
                    <LeadDashboard ref={componentRef} setFilters={setFilters}/>
                </TabPanel>
            </Tabs>
        </Box>
    );
}

export default LeadsDashboard;


